import React from "react";
import OfficeAndWorkers from "../filterDockets/OfficeAndWorkers";

const DocketsFilterHead = React.memo(({ data, setData, workers }) => {
    return (
        <div className={"InvoicesListFilter"}>

            <p>מיין לפי</p>
            <select
                value={data.sortOption}
                onChange={(event) => setData({ ...data, sortOption: event.target.value })}
            >
                <option value="docketAsc">מספר דוקט - מהנמוך לגבוה</option>
                <option value="docketDesc">מספר דוקט - מהגבוה לנמוך</option>
                <option value="dateAsc">תאריך - מהמוקדם למאוחר</option>
                <option value="dateDesc">תאריך - מהמאוחר למוקדם</option>
            </select>

            <p>מספר דוקט</p>
            <input
                type="number"
                value={data.docket_id}
                onChange={(event) => setData({ ...data, docket_id: event.target.value })}
                placeholder="הכל"
                style={{ width: '7em' }}
            />

            <p>שם</p>
            <input
                type="text"
                value={data.name || ""}
                onChange={(event) => setData({ ...data, name: event.target.value })}  // Handle the name input change
                placeholder="הכל"
                style={{ width: '10em' }}
            />


            <p>תאריך התחלה</p>
            <input
                type="date"
                value={data.date_f}
                onChange={(event) => setData({ ...data, date_f: event.target.value })}
            />

            <p>תאריך סיום</p>
            <input
                type="date"
                value={data.date_e}
                onChange={(event) => setData({ ...data, date_e: event.target.value })}
            />

            <OfficeAndWorkers
                officeValue={data.office}
                setOfficeValue={(v) => setData({ ...data, office: v, work: "*" })}
                workValue={data.work}
                setWorkValue={(v) => setData({ ...data, work: v })}
                workers={workers}
            />
        </div>
    );
});

export default DocketsFilterHead;